import React from "react";
import { thoughts } from "../data/thoughts";
import { SectionHeading } from "./SectionHeading";
import { ThoughtFeature } from "./ThoughtFeature";
export function FeaturedThought() {
  const post = thoughts[0];
  if (!post) return null;
  return <section id="thoughts" aria-labelledby="thoughts-heading" className="w-full scroll-mt-28 bg-cream px-6 pb-24 md:scroll-mt-36 md:px-12 md:pb-32 lg:px-20 lg:pb-40" data-id="element-307" data-mp="14nqyaot8iplf">
      <SectionHeading id="thoughts-heading" title="THOUGHTS" data-id="element-308" data-mp="1whszv3k0hu3w" />
      <ThoughtFeature thought={post} data-id="element-309" data-mp="21gcppf1q7q1j" />
    </section>;
}